module.exports = __webpack_public_path__ + "prod/1.42.2/img/bdcz.f2405df1.png";